import { FIELD_REGEXP } from '@common/utils/regExp'

export default {
    data() {
        const validateCnName = (rule, value, callback) => {
            if (value.length > 50) {
                callback(
                    new Error('输入的名称不能超过50个字')
                )
                return
            }
            callback()
        }
        const validateField = (rule, value, callback) => {
            if (value.length > 30) {
                callback(
                    new Error('输入的字段不能超过30个字')
                )
                return
            }
            if (!FIELD_REGEXP.test(value)) {
                callback(new Error('请输入英文、数字、下划线，英文字母开头，不以下划线结尾，且不包含2个连续下划线'))
                return
            }
            callback()
        }
        return {
            rulesObj: {
                title: [{
                    required: true,
                    message: '请输入显示名称',
                    trigger: 'blur',
                }, { validator: validateCnName, trigger: 'blur' }],
                name: [{
                    required: true,
                    message: '请输入字段名称',
                    trigger: 'blur',
                },
                { validator: validateField, trigger: 'blur' }],
                type: [{
                    required: true,
                    message: '请选择字段类型',
                    trigger: 'blur',
                }],
                typeObjectId: [{
                    required: true,
                    message: ' ',
                    trigger: 'change',
                }],
            },
        }
    },
    computed: {
        defaultValRules() {
            const { type, config = {} } = this.apiParamObj
            const rules = []
            if (type === 'string' || type === 'number') {
                const {
                    textLengthRange,
                    // integerLength,
                    // decimalDigit,
                } = config
                if (textLengthRange) {
                    rules.push({
                        min: textLengthRange[0], max: textLengthRange[1], message: `长度在 ${textLengthRange[0]} 到 ${textLengthRange[1]} 个字符`, trigger: 'blur',
                    })
                }
                // if (integerLength) {
                //     rules.push({
                //         validator: (rule, value, callback) => {
                //             const valToStr = String(value)
                //             const interger = valToStr.split('.')[0]
                //             if (interger.length > integerLength) {
                //                 callback(
                //                     new Error('输入的数值超过整数长度限制')
                //                 )
                //                 return
                //             }
                //             callback()
                //         },
                //     })
                // }
                // if (decimalDigit) {
                //     rules.push({
                //         validator: (rule, value, callback) => {
                //             const valToStr = String(value)
                //             const decimal = valToStr.split('.')[1] || ''
                //             if (decimal.length > decimalDigit) {
                //                 callback(
                //                     new Error('输入的数值超过保留小数限制')
                //                 )
                //                 return
                //             }
                //             callback()
                //         },
                //     })
                // }
            }
            return rules
        },
    },
}
